import type { ChatMessage } from '@/lib/types';
import { EddyAvatar } from './EddyAvatar';

interface MessageBubbleProps {
  message: ChatMessage;
  streaming?: boolean;
}

export function MessageBubble({ message, streaming }: MessageBubbleProps) {
  const isUser = message.role === 'user';
  const isEmpty = message.content.length === 0;

  return (
    <div className={`flex gap-3 ${isUser ? 'justify-end' : 'justify-start'}`}>
      {!isUser && <EddyAvatar size={32} className="mt-0.5 shrink-0" />}
      <div
        className={`max-w-[78%] whitespace-pre-wrap rounded-2xl px-4 py-2.5 text-[15px] leading-relaxed ${
          isUser
            ? 'rounded-br-md bg-brand-600 text-white'
            : 'rounded-bl-md bg-white text-ink shadow-sm ring-1 ring-brand-100'
        }`}
      >
        {isEmpty && streaming ? (
          <span className="inline-flex gap-1 py-1">
            <span className="eddy-dot h-2 w-2 rounded-full bg-brand-400" />
            <span className="eddy-dot h-2 w-2 rounded-full bg-brand-400" />
            <span className="eddy-dot h-2 w-2 rounded-full bg-brand-400" />
          </span>
        ) : (
          message.content
        )}
      </div>
    </div>
  );
}
